/*----------------------------------
- WEBSITE ICON SPRITE MANIFEST
----------------------------------*/

/**
 * @docs docs/features/website-seo-performance
 *
 * GENERATED by `scripts/website/build-icon-sprite.mjs`. Do not edit by hand: run the script.
 *
 * `SPRITE_URL` is content-hashed so Proteum serves it `immutable` for a year; the hash changes
 * whenever the icon set or lucide itself changes, which is what invalidates the cached file.
 */

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const SPRITE_URL = '/public/icons/lucide.98510f1693.svg';

/** Website icon name to its sprite fragment id and the exact class string lucide-preact renders. */
export const SPRITE_ICON_IDS = {
    'alert': { id: 'triangle-alert', class: 'lucide lucide-triangle-alert' },
    'anchor': { id: 'anchor', class: 'lucide lucide-anchor' },
    'archive': { id: 'archive', class: 'lucide lucide-archive' },
    'arrow-down': { id: 'arrow-down', class: 'lucide lucide-arrow-down' },
    'arrow-left': { id: 'arrow-left', class: 'lucide lucide-arrow-left' },
    'arrow-right': { id: 'arrow-right', class: 'lucide lucide-arrow-right' },
    'arrow-up': { id: 'arrow-up', class: 'lucide lucide-arrow-up' },
    'arrow-up-right': { id: 'arrow-up-right', class: 'lucide lucide-arrow-up-right' },
    'bell': { id: 'bell', class: 'lucide lucide-bell' },
    'book-open': { id: 'book-open', class: 'lucide lucide-book-open' },
    'bookmark': { id: 'bookmark', class: 'lucide lucide-bookmark' },
    'bot': { id: 'bot', class: 'lucide lucide-bot' },
    'calendar': { id: 'calendar', class: 'lucide lucide-calendar' },
    'chart-bar': { id: 'chart-column', class: 'lucide lucide-chart-column' },
    'chart-line': { id: 'chart-line', class: 'lucide lucide-chart-line' },
    'check': { id: 'check', class: 'lucide lucide-check' },
    'chevron-down': { id: 'chevron-down', class: 'lucide lucide-chevron-down' },
    'chevron-left': { id: 'chevron-left', class: 'lucide lucide-chevron-left' },
    'chevron-right': { id: 'chevron-right', class: 'lucide lucide-chevron-right' },
    'chevron-up': { id: 'chevron-up', class: 'lucide lucide-chevron-up' },
    'clock': { id: 'clock', class: 'lucide lucide-clock' },
    'cloud': { id: 'cloud', class: 'lucide lucide-cloud' },
    'code': { id: 'code', class: 'lucide lucide-code' },
    'coins': { id: 'coins', class: 'lucide lucide-coins' },
    'columns': { id: 'columns3', class: 'lucide lucide-columns3 lucide-columns-3' },
    'compass': { id: 'compass', class: 'lucide lucide-compass' },
    'copy': { id: 'copy', class: 'lucide lucide-copy' },
    'crosshairs': { id: 'crosshair', class: 'lucide lucide-crosshair' },
    'database': { id: 'database', class: 'lucide lucide-database' },
    'dollar': { id: 'dollar-sign', class: 'lucide lucide-dollar-sign' },
    'download': { id: 'download', class: 'lucide lucide-download' },
    'droplet': { id: 'droplet', class: 'lucide lucide-droplet' },
    'ellipsis': { id: 'ellipsis', class: 'lucide lucide-ellipsis' },
    'eye': { id: 'eye', class: 'lucide lucide-eye' },
    'eye-off': { id: 'eye-off', class: 'lucide lucide-eye-off' },
    'feed': { id: 'newspaper', class: 'lucide lucide-newspaper' },
    'file-text': { id: 'file-text', class: 'lucide lucide-file-text' },
    'filter': { id: 'funnel', class: 'lucide lucide-funnel' },
    'flame': { id: 'flame', class: 'lucide lucide-flame' },
    'folder': { id: 'folder', class: 'lucide lucide-folder' },
    'gavel': { id: 'gavel', class: 'lucide lucide-gavel' },
    'github': { id: 'github', class: 'lucide lucide-github' },
    'globe': { id: 'globe', class: 'lucide lucide-globe' },
    'globe-2': { id: 'earth', class: 'lucide lucide-earth' },
    'grid-2x2': { id: 'grid2x2', class: 'lucide lucide-grid2x2 lucide-grid-2x2' },
    'grip-vertical': { id: 'grip-vertical', class: 'lucide lucide-grip-vertical' },
    'hammer': { id: 'hammer', class: 'lucide lucide-hammer' },
    'heart': { id: 'heart', class: 'lucide lucide-heart' },
    'home': { id: 'house', class: 'lucide lucide-house' },
    'instagram': { id: 'instagram', class: 'lucide lucide-instagram' },
    'layers': { id: 'layers', class: 'lucide lucide-layers' },
    'link': { id: 'link', class: 'lucide lucide-link' },
    'linkedin': { id: 'linkedin', class: 'lucide lucide-linkedin' },
    'list-filter': { id: 'list-filter', class: 'lucide lucide-list-filter' },
    'lock': { id: 'lock', class: 'lucide lucide-lock' },
    'log-out': { id: 'log-out', class: 'lucide lucide-log-out' },
    'mail': { id: 'mail', class: 'lucide lucide-mail' },
    'medal': { id: 'medal', class: 'lucide lucide-medal' },
    'menu': { id: 'menu', class: 'lucide lucide-menu' },
    'message-circle': { id: 'message-circle', class: 'lucide lucide-message-circle' },
    'minus': { id: 'minus', class: 'lucide lucide-minus' },
    'monitor': { id: 'monitor', class: 'lucide lucide-monitor' },
    'moon': { id: 'moon', class: 'lucide lucide-moon' },
    'pause': { id: 'pause', class: 'lucide lucide-pause' },
    'pencil': { id: 'pencil', class: 'lucide lucide-pencil' },
    'play': { id: 'play', class: 'lucide lucide-play' },
    'plus': { id: 'plus', class: 'lucide lucide-plus' },
    'radar': { id: 'radar', class: 'lucide lucide-radar' },
    'radio': { id: 'radio', class: 'lucide lucide-radio' },
    'refresh': { id: 'refresh-cw', class: 'lucide lucide-refresh-cw' },
    'rss': { id: 'rss', class: 'lucide lucide-rss' },
    'search': { id: 'search', class: 'lucide lucide-search' },
    'settings': { id: 'settings', class: 'lucide lucide-settings' },
    'share': { id: 'share2', class: 'lucide lucide-share2 lucide-share-2' },
    'shield': { id: 'shield', class: 'lucide lucide-shield' },
    'shield-check': { id: 'shield-check', class: 'lucide lucide-shield-check' },
    'sigma': { id: 'sigma', class: 'lucide lucide-sigma' },
    'sliders': { id: 'sliders-horizontal', class: 'lucide lucide-sliders-horizontal' },
    'sparkles': { id: 'sparkles', class: 'lucide lucide-sparkles' },
    'star': { id: 'star', class: 'lucide lucide-star' },
    'stars': { id: 'sparkles', class: 'lucide lucide-sparkles' },
    'stethoscope': { id: 'stethoscope', class: 'lucide lucide-stethoscope' },
    'store': { id: 'store', class: 'lucide lucide-store' },
    'sun': { id: 'sun', class: 'lucide lucide-sun' },
    'tag': { id: 'tag', class: 'lucide lucide-tag' },
    'target': { id: 'target', class: 'lucide lucide-target' },
    'trash': { id: 'trash2', class: 'lucide lucide-trash2 lucide-trash-2' },
    'trending-down': { id: 'trending-down', class: 'lucide lucide-trending-down' },
    'trending-up': { id: 'trending-up', class: 'lucide lucide-trending-up' },
    'triangle': { id: 'triangle', class: 'lucide lucide-triangle' },
    'twitter': { id: 'twitter', class: 'lucide lucide-twitter' },
    'unlock': { id: 'lock-open', class: 'lucide lucide-lock-open' },
    'user': { id: 'user', class: 'lucide lucide-user' },
    'user-round': { id: 'user-round', class: 'lucide lucide-user-round' },
    'users': { id: 'users', class: 'lucide lucide-users' },
    'waves': { id: 'waves', class: 'lucide lucide-waves' },
    'x': { id: 'x', class: 'lucide lucide-x' },
} as const;

export type SpriteIconName = keyof typeof SPRITE_ICON_IDS;
